import { NavNode } from '../../utils';
import { NavigationItem } from './NavigationItem';

export function PlaceholderPage({ page }: { page: NavNode }) {
  return (
    <div className="opacity-50">
      <NavigationItem hideTooltip navNode={page} />
    </div>
  );
}
